var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-home-slideshow"},[(_vm.slides.length)?_c('carousel',{attrs:{"autoplay":true,"loop":true,"nav":false,"margin":10,"center":true,"responsive":( _obj = { 0: { items: 1 } }, _obj[_vm.smThreshold] = { items: 3 }, _obj ),"auto-width":!_vm.sm}},_vm._l((_vm.slides),function(ref,i){
var img = ref.img;
var link = ref.link;
var target = ref.target;
return _c('v-card',{key:i,attrs:{"href":link,"target":target,"flat":"","tile":""}},[_c('img',{staticClass:"page-home-carousel-img",attrs:{"src":img}})])}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }